"use strict";
/*
 * Created on 17. 7. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * This is common-be-fe equivalent of YDGOptResultStrategyData independent on yieldigo-client module.
 * @author Radek Beran
 */


var StrategyGraphData =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(StrategyGraphData, _DomainObject_1$Domai);

  function StrategyGraphData(profit, revenue, quantity, margin) {
    var _this;

    _classCallCheck(this, StrategyGraphData);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StrategyGraphData).call(this));
    _this.profit = profit;
    _this.revenue = revenue;
    _this.quantity = quantity;
    _this.margin = margin;
    return _this;
  }

  return StrategyGraphData;
}(DomainObject_1.DomainObject);

exports.StrategyGraphData = StrategyGraphData;

StrategyGraphData.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(StrategyGraphData.name);
  return {
    profit: builder.num('profit'),
    revenue: builder.num('revenue'),
    quantity: builder.num('quantity'),
    margin: builder.num('margin')
  };
}();